
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trip-detail",
      function () {
        return require("private-next-pages/trip-detail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trip-detail"])
      });
    }
  